"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotAuthorizedError = exports.ValidationError = exports.NotFoundError = exports.ForbiddenError = exports.APIError = void 0;
const httpStatus = __importStar(require("http-status"));
/**
 * @extends Error
 */
class ExtendableError extends Error {
    // @ts-ignore
    constructor({ message, errors, status, isPublic, stack }) {
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.errors = errors;
        this.status = status;
        this.isPublic = isPublic;
        this.isOperational = true; // This is required since bluebird 4 doesn't append it anymore.
        this.stack = stack || this.stack; // If stack is not provided use the original
    }
}
class APIError extends ExtendableError {
    // @ts-ignore
    constructor({ message, errors = null, stack = null, status = httpStatus.INTERNAL_SERVER_ERROR, isPublic = false }) {
        super({
            message,
            errors,
            status,
            isPublic,
            stack,
        });
    }
}
exports.APIError = APIError;
class ForbiddenError extends APIError {
    constructor(message = 'Forbidden') {
        super({
            message,
            status: httpStatus.FORBIDDEN,
        });
    }
}
exports.ForbiddenError = ForbiddenError;
class NotFoundError extends APIError {
    constructor(message = 'Not found') {
        super({
            message,
            status: httpStatus.NOT_FOUND,
        });
    }
}
exports.NotFoundError = NotFoundError;
class ValidationError extends APIError {
    // @ts-ignore
    constructor(message) {
        super({
            message,
            status: httpStatus.BAD_REQUEST,
        });
    }
}
exports.ValidationError = ValidationError;
class NotAuthorizedError extends APIError {
    // @ts-ignore
    constructor(message = 'Not authorized') {
        super({
            message,
            status: httpStatus.UNAUTHORIZED,
        });
    }
}
exports.NotAuthorizedError = NotAuthorizedError;
